import { render, staticRenderFns } from "./RejectDescription.vue?vue&type=template&id=80f7b86a&"
import script from "./RejectDescription.vue?vue&type=script&lang=js&"
export * from "./RejectDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports